export const NUMERIC_LOCALE_ZHCHS = {
    placeholder: 'è¯·è¾å¥æ°å­',
    range: {
        begin: 'è¯·è¾å¥å¼å§æ°å­',
        end: 'è¯·è¾å¥ç»ææ°å­'
    }
};
